import script from "./MyProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProjects.vue?vue&type=script&setup=true&lang=js"

import "./MyProjects.vue?vue&type=style&index=0&id=9b3f2e44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b3f2e44"]])

export default __exports__